import { useQuery } from '@tanstack/react-query';
import { searchCryptocurrencies as searchCrypto, type CryptoCurrency } from '../coingecko';

/**
 * React Query hook for searching cryptocurrencies
 * Uses CoinGecko with automatic fallback to LiveCoinWatch
 *
 * @param query - Search query (minimum 2 characters)
 * @returns Query result with cryptocurrency list
 */
export const useSearchCryptocurrencies = (query: string) => {
  return useQuery<CryptoCurrency[], Error>({
    queryKey: ['crypto-search', query],
    queryFn: () => searchCrypto(query),
    enabled: query.length > 0,
    staleTime: 5 * 60 * 1000, // 5 minutes - equivalent to manual cache duration
    gcTime: 10 * 60 * 1000, // 10 minutes
  });
};
